/**
 * Secondary row — podcast block on the left, email opt-in pitch on the right.
 * Sits between the inline CTA and the footer. Pure render.
 *
 * Email opt-in is a link out to thecranialdoc.com (no inline form — preserves
 * the zero-third-party-runtime rule and CSP self-only).
 */

import { el } from "../dom";
import { MARKETING } from "../marketing";

import "./secondary-row.css";

export interface SecondaryRowHandle {
  el: HTMLElement;
}

export function createSecondaryRow(): SecondaryRowHandle {
  const podcast = el(
    "div",
    { class: "secondary-row__cell" },
    el("h3", { class: "secondary-row__title" }, MARKETING.podcast.title),
    el("p", { class: "secondary-row__body" }, MARKETING.podcast.description),
    el(
      "a",
      {
        href: MARKETING.podcast.url,
        class: "secondary-row__link",
        target: "_blank",
        rel: "noopener noreferrer",
      },
      MARKETING.podcast.linkLabel,
    ),
  );

  const email = el(
    "div",
    { class: "secondary-row__cell" },
    el("h3", { class: "secondary-row__title" }, MARKETING.emailOptIn.title),
    el("p", { class: "secondary-row__body" }, MARKETING.emailOptIn.description),
    el(
      "a",
      {
        href: MARKETING.emailOptIn.url,
        class: "secondary-row__link",
        target: "_blank",
        rel: "noopener noreferrer",
      },
      `${MARKETING.emailOptIn.label} →`,
    ),
  );

  const root = el(
    "section",
    { class: "secondary-row no-print", "aria-label": MARKETING.secondaryRowLabel },
    el("div", { class: "container secondary-row__inner" }, podcast, email),
  );

  return { el: root };
}
